import { ItemCategory } from '../items/types.js';
// Categories available for filtering (uses existing ItemCategory)
export const STOCKPILE_CATEGORY_INFO = [
    { id: ItemCategory.NONE, name: 'All', icon: 'all' },
    { id: ItemCategory.RAW_MATERIAL, name: 'Raw Materials', icon: 'raw' },
    { id: ItemCategory.PROCESSED_MATERIAL, name: 'Processed', icon: 'processed' },
    { id: ItemCategory.FOOD, name: 'Food', icon: 'food' },
    { id: ItemCategory.TOOL, name: 'Tools', icon: 'tools' },
    { id: ItemCategory.WEAPON, name: 'Weapons', icon: 'weapons' },
];
// ============================================================================
// Helpers
// ============================================================================
// Get category for an item type based on its numeric range
export const getItemCategoryFromType = ({ itemType, }) => {
    if (itemType >= 1 && itemType < 100) {
        return ItemCategory.RAW_MATERIAL;
    }
    if (itemType >= 100 && itemType < 200) {
        return ItemCategory.PROCESSED_MATERIAL;
    }
    if (itemType >= 200 && itemType < 300) {
        return ItemCategory.FOOD;
    }
    if (itemType >= 300 && itemType < 400) {
        return ItemCategory.TOOL;
    }
    if (itemType >= 400 && itemType < 500) {
        return ItemCategory.WEAPON;
    }
    return ItemCategory.NONE;
};
// Get category name for display
export const getCategoryName = ({ category }) => {
    const info = STOCKPILE_CATEGORY_INFO.find((c) => c.id === category);
    return info?.name ?? 'Unknown';
};
//# sourceMappingURL=types.js.map